// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Accordion_wrapper__fl3X5","text":"Accordion_text__vGQzq","link":"Accordion_link__1OLKi"};